import { UPLOAD_DOMAIN } from "@/config";
import api from "./api";

export const $get_getOssProperties = (params) => api.postNoMessage("/hengxin/erp/api/platform/biz/oss/getOssSignature", params);

// export const $post_uploadRequest = (params) => api.postNoMessage(UPLOAD_DOMAIN, params);
export const $post_uploadRequest = (params) => api.postNoRejectNoTips('/hengxin/erp/api/platform/biz/upload', params);

export const $sp_querySysConfigByKeyCommon = params => api.postNoTips("/hengxin/erp/api/client/biz/sysConfigResource/querySysConfigByKeyCommon", params);

//注册
export const $sp_register = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/register", params);

// 账号密码登录
export const $sp_passwordLogin = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/doLogin", params);

// 发送验证码
export const $sp_sendSms = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/sendSms", params);

// 发送验证码V2
export const $sp_sendSmsV2 = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/sendSms2", params);

// 验证码登录
export const $sp_smsLogin = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/smsLogin", params);

// 保存登陆设备和程序信息
export const $sp_saveDeviceAndProgram = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/saveDeviceAndProgram", params);

//帮助的中心 售后规则/服务条款/关于我们
export const $sp_getHelpRule = params => api.get("/hengxin/erp/api/client/biz/my/informationInfo", params);

//公告详情
export const $sg_noticeInfo = params => api.getNoTips("/hengxin/erp/api/client/biz/notice/info", params);

// 修改用户手机号
export const $sp_updatePhone = params => api.postNoTips("/hengxin/erp/api/client/biz/my/secure/updatePhone", params);
